export const springCloudS3Snippet =
`spring.cloud.aws.s3:
   endpoint: s3.eu-central-1.amazonaws.com
   region: eu-central-1
`

export const springCloudS3ReferenceSnippet =
`nca.ds.core:
  config-storage-json:
    resource-location: s3://bucket/ds-config.json`

export const springCloudSecretsManagerSnippet =
`spring.cloud.aws.secretsmanager:
   endpoint: s3.eu-central-1.amazonaws.com
   region: eu-central-1
`

export const springCloudSecretsManagerUsageSnippet =
`# loading a single secret
spring.config.import: aws-secretsmanager:/secrets/database-secrets

# loading multiple secrets delimited by ;
spring.config.import: aws-secretsmanager:/secrets/database-secrets;/secrets/webclient-secrets
 
# loading a required and optional secret
spring.config.import:
  - aws-secretsmanager=/secrets/required-secret
  - optional:aws-secretsmanager=/secrets/optional-secret
`

export const springCloudSecretsManagerReferenceSnippet =
`spring:
  config.import:
     - aws-secretsmanager:/secrets/database-secrets
  datasource: 
    url: jdbc:postgresql://dbhost:5432/dbname
    username: \${db-user}
    password: \${db-password}
`

export const springCloudParameterStoreUsageSnippet =
`# loading a single parameter
spring.config.import: aws-parameterstore:/config/spring

# loading multiple parameters delimited by ;
spring.config.import: aws-parameterstore:/config/spring;/config/app
 
# loading a required and optional parameter
spring.config.import:
  - aws-parameterstore:/config/spring   
  - optional:aws-parameterstore:/config/optional-params/
`

export const springCloudParameterStoreSnippet =
`spring.cloud.aws.parameterstore:
   endpoint: s3.eu-central-1.amazonaws.com
   region: eu-central-1
`

export const springCloudParameterStoreReferenceSnippet =
`spring:
  config.import:
    - aws-parameterstore:/config/3ds-ds
  datasource:
    url: jdbc:postgresql://\${db-host}:5432/\${db-name}
`
